/**
 * Section-level behaviors for theme.home layout
 * - FAQ accordion (faq-questions, faq-question)
 * - Smooth scroll for anchor links
 */
(function () {
  'use strict';

  // FAQ accordion: show/hide answers on click
  $(document).on('click', '.faq-questions, .faq-question', function () {
    const $clicked = $(this);
    const isActive = $clicked.hasClass('active');

    // Reset all: remove active and set icon to +
    $('.faq-questions, .faq-question')
      .removeClass('active')
      .find('.toggle-icons')
      .text('+')
      .end()
      .next()
      .slideUp();

    // If not active, activate clicked and show minus
    if (!isActive) {
      $clicked.addClass('active').find('.toggle-icons').text('–');
      $clicked.next().slideDown();
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      const offset = 50;
      if (target) {
        const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
          top: topPosition,
          behavior: document.documentElement.hasAttribute('data-no-smooth-scroll') ? 'auto' : 'smooth'
        });
      }
    });
  });
})();
